// src/context/BreadcrumbContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  // Map of path segments to custom labels, e.g., { "1": "Greenwood Apartments" }
  const [customLabels, setCustomLabels] = useState({});
  
  // Custom breadcrumb path override (array of { label, path } objects)
  const [customPath, setCustomPathState] = useState(null);

  const setLabel = useCallback((key, label) => {
    setCustomLabels((prev) => ({ ...prev, [key]: label }));
  }, []);

  const clearLabel = useCallback((key) => {
    setCustomLabels((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  }, []);

  const getLabel = useCallback((key) => {
    return customLabels[key] || null;
  }, [customLabels]);

  // Set a complete custom breadcrumb path
  // e.g., [{ label: "Properties", path: "/properties" }, { label: "Greenwood", path: "/properties/1/details" }, { label: "Unit 1A", path: null }]
  const setCustomPath = useCallback((path) => {
    setCustomPathState(path);
  }, []);

  const clearCustomPath = useCallback(() => {
    setCustomPathState(null);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ 
      setLabel, 
      clearLabel, 
      getLabel, 
      customLabels,
      customPath,
      setCustomPath,
      clearCustomPath,
    }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error("useBreadcrumb must be used within BreadcrumbProvider");
  }
  return context;
};

